import { Resource, Identifier } from '@medplum/fhirtypes';
import { HEALTHIE_SYSTEM_URL } from './constants';

export function hasHealthieSourceOrIdentifier<T extends Resource & { identifier?: Identifier[] }>(
  resource: T
): boolean {
  // Check meta.source first if it exists (more accurate for migrated resources)
  if (resource.meta?.source) {
    return resource.meta.source.includes('healthie') || resource.meta.source.includes('Healthie');
  }

  // Fallback to identifier check (current behavior)
  return resource.identifier?.find((identifier) => identifier.system === HEALTHIE_SYSTEM_URL) !== undefined;
}
